import React from 'react';
import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import MarketStats from '../components/crypto/MarketStats';
import Testimonials from '../components/home/Testimonials';
import ContactForm from '../components/home/ContactForm';
import Newsletter from '../components/home/Newsletter';
import Chatbot from '../components/common/Chatbot';
import BackToTop from '../components/common/BackToTop';
import HowItWorks from '../components/home/HowItWorks';
import FAQ from '../components/common/FAQ';
import WalletGuide from '../components/common/WalletGuide';

export default function HomePage() {
  return (
    <>
      <Hero />
      <div className="container mx-auto px-4 py-12 space-y-24">
        <MarketStats />
        <HowItWorks />
        <WalletGuide />
        <Features />
        <FAQ />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <ContactForm />
          <Newsletter />
        </div>
        <div className="max-w-3xl mx-auto">
          <Testimonials />
        </div>
      </div>
      <Chatbot />
      <BackToTop />
    </>
  );
}